var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionCableProvider',{attrs:{"channelName":"PatientIssuesChatChannel","listeners":{ connected: _vm.connected, received: _vm.received },"autoReconnect":false}})}
var staticRenderFns = []

export { render, staticRenderFns }